import { AudioManager } from "./../../../managers/AudioManager";
import { GameVars } from "../../../GameVars";

export class BananaSpine extends Phaser.GameObjects.Container {

    private spine: any;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.spine = (this.scene.add as any).spine(0, 0, "bananaExp");
        this.spine.skeleton.setToSetupPose();
        this.add(this.spine);

        this.spine.setScale(GameVars.scaleX, GameVars.scaleY);

        // this.spine.play("neutral", true);

        this.spine.state.listeners[0].complete = (trackIndex: any) => {
            if (trackIndex.animation.name === "blink") {
                this.spine.clearTrack(2);
            }
        };

        this.spine.state.listeners[0].event = (trackIndex: any, event: any) => {

            try {
                if (this.visible) {
                    AudioManager.playSound("banana_" + event.data.name);
                }
            } catch (error) {
                // 
            }
                     
        };
    }

    public setAvatarState(state: string, loop?: boolean): void {

        this.spine.play(state, loop || false);
    }

    public setTempState(state: string): void {

        this.spine.play(state);
    }

    public setAvatarAnimation(anim: string): void {

        try {
            this.spine.setAnimation(2, anim);
        } catch (error) {
            // 
        }
        
    }
}
